export const CSS_CLASSES = {
  LIST_ROOT: "list",
  LIST_ITEM_ELEMENT: "list-item-element",
  LIST_ICON: "list-icon",
  SUB_LIST: "sub-list",
  LIST_DECIMAL: "list-decimal",
  LIST_LOWER_ALPHA: "list-lower-alpha",
  LIST_UPPER_ALPHA: "list-upper-alpha",
  LIST_LOWER_ROMAN: "list-lower-roman",
  LIST_UPPER_ROMAN: "list-upper-roman",

  LIST_SMALL: "list-small",
  LIST_MEDIUM: "list-medium",
  LIST_LARGE: "list-large",

  LIST_PRIMARY_COLOR: "list-primary-color",
  LIST_SECONDARY_COLOR: "list-secondary-color",
  LIST_ACCENT_COLOR: "list-accent-color",
  LIST_GRAY_COLOR: "list-gray-color",
  LIST_SUCCESS_COLOR: "list-success-color",
  LIST_WARNING_COLOR: "list-warning-color",
  LIST_ERROR_COLOR: "list-error-color",
};
